import { getTranslation } from '@easy-expense/intl-client';
import { Icon } from '@easy-expense/ui-shared-components';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

/**
 * Way out of a checkout the buyer changed their mind about. Rendered only where there is somewhere
 * to go: a checkout opened from inside ee-web came from a page worth returning to, where a handoff
 * opened a fresh tab with nothing behind it. The destination is explicit rather than a history
 * step back, which after a failed load and a retry need not be where the buyer came from.
 */
export const CheckoutBackLink: React.FC<{ onPress: () => void }> = ({ onPress }) => (
  <Layout.Row>
    <Layout.PressableRow
      align
      py={4}
      bg="transparent"
      onClick={onPress}
      style={{ cursor: 'pointer' }}
    >
      <Icon name="chevron-back" size={16} color={theme.colors.secondary} />
      <Spacer.Horizontal size={4} />
      <OpenSans.Secondary size="xs-12">{getTranslation('Back')}</OpenSans.Secondary>
    </Layout.PressableRow>
  </Layout.Row>
);
